<template>
    <div class="page_home_hx flex-col">

        <div class="box_33 flex-col">
            <div class="block_95 flex-row">
                <div class="text-group_367 flex-col justify-between">
                    <span class="text_74">新闻中心</span>
                    <span class="text_75">NEWS&nbsp;CENTER</span>
                </div>
            </div>
            <div class="block-container">
                <div class="block_96 main-news">
                    <div class="group_184 flex-col justify-between">
                        <div class="box_36 flex-col" >
                            <div
                                    v-if="newsMainObj && newsMainObj.pic"
                                    class="box36_content"
                                    :style="bannerStyle"
                            ></div>
                        </div>
                        <div class="box_37 flex-col justify-end">
                            <span class="text_76">{{newsMainObj.publishTime}}</span>
                            <span class="text_77" @click="goToDetail(newsMainObj)">{{newsMainObj.title}}</span>
                            <div class="text_78 clamp-2" v-html="newsMainObj.introduce" @click="goToDetail(newsMainObj)"></div>
                            <div class="image-text_270 flex-row justify-between" >
                                <span class="text-group_28" @click="goToMore('Information')">查看更多</span>
                                <img
                                        class="thumbnail_1"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/index/chpc_index.map_04.png"
                                />
                            </div>
                            <div class="box_38 flex-col"></div>
                        </div>
                    </div>
                </div>

                <div class="block_96 news-list">
                    <div class="group_185 flex-col justify-between">
                        <div class="group_36 flex-col justify-end" v-for="(item, index) in newsList" :key="index" >
                            <div class="text-group_369 flex-col justify-between">
                                <span class="text_81">{{item.publishTime}}</span>
                                <span class="text_82" @click="goToDetail(item)">{{item.title}}</span>
                            </div>
                            <div class="box_40 flex-col"></div>
                        </div>

                        <div class="group_40 flex-row">
                            <div class="image-text_271 flex-row justify-between" @click="goToMore('Information')">
                                <span class="text-group_33">查看更多</span>
                                <img
                                        class="thumbnail_2"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/index/chpc_index.map_04.png"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>

    </div>
</template>
<script>

    import {formartDate} from "../../../common/testFun";
    export default {
        props: {
            datalist: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                serverCount: [0, 0, 0, 0, 0, 0, 0, 0], // 初始值设为0
                targetValues: [20, 30, 100, 300, 900, 7000, 8000, 590], // 目标值
                hasAnimated: false, // 防止重复触发

                //主图新闻
                newsMainObj: {
                    pic: '',
                    publishTime: '',
                    title: '',
                    content: '',
                    introduce:'',
                },
                newsList:[],

            };
        },
        computed: {
            bannerStyle() {
                return {
                    backgroundImage: `url(${this.newsMainObj.pic})`,
                    backgroundSize: 'cover', // 保持背景图片等比缩放
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat'
                };
            }
        },
        methods: {

            // 实现两种跳转方式
            goToDetail(item) {
                // 添加防御性判断
                if (this.$route.path === '/news') return; // 阻止重复跳转

                this.$router.push({
                    path: '/news',
                    query: { id: item.id }
                }).catch(err => {
                    // 捕获路由重复跳转的异常
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('Navigation error:', err);
                    }
                });

                window.scrollTo(0, 0);
            },
            goToMore(url) {
                url = '/' + url;
                this.$router.push(url, () => {
                    // 导航完成后的回调
                    window.scrollTo(0, 0)
                })
            },
        },
        watch: {
            datalist: {
                handler(newVal) {
                    let data = newVal.menuList;
                    //this.newsMainObj = newVal.main;
                    if(newVal.main){
                        this.newsMainObj = {
                            ...this.newsMainObj, // 保留原有结构
                            id:newVal.main.id,
                            pic: newVal.main.pic || '',
                            title: newVal.main.title || '',
                            content: newVal.main.content || '',
                            introduce:newVal.main.introduce || '',
                            publishTime: newVal.main.publishTime
                                ? formartDate(newVal.main.publishTime)
                                : ''
                        };
                    }
                    if(this.newsMainObj){
                        if(newVal.main && newVal.main.publishTime) {
                            let ttime =   formartDate(newVal.main.publishTime);
                            this.newsMainObj.publishTime = ttime;
                        }
                    }
                    if(newVal && newVal.newsList){
                        this.newsList = newVal.newsList.map(item=>{
                            if(item.publishTime){
                                item.publishTime  = formartDate(item.publishTime);
                            }else{
                                item.publishTim = '';
                            }
                            return item;
                        });
                        //console.log(this.newsList)
                    }

                },
                immediate: true
            },
        }
    };
</script>

<style scoped lang="css"  >

    .page_home_hx {

    }

    .box_33 {

        background: url(../../../assets/index/chpc_home_index_hx_01.png) 100% no-repeat;
        background-size: 100% 100%;
        margin-top: -1px;
        margin: -1px auto 0 auto;
        width: 100%;
        max-width: 1200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        /*min-height: 843px; */
        height: auto;
    }

    .block_95 {
        width: 193px;
        margin: 60px auto 0;
    }

    .text-group_367 {
        width: 193px;
    }

    .text_74 {
        width: 152px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin-left: 20px;
    }

    .text_75 {
        width: 193px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: center;
        white-space: nowrap;
        line-height: 31px;
        margin-top: 6px;
    }

    /* 新增容器样式 */
    .block-container {
        width: 100%;
        max-width: 1200px;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;
    }

    .main-news {
        flex: 1;
        max-width: 768px;
    }

    .news-list {
        width: 100%;
        max-width: 768px;
    }
    .block_96.news-list,
    .block_96.main-news {

        margin: 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .block_96 {
        width: 100%;
        max-width: 1200px;

        height: auto;
        margin: 0 !important;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .group_184 {
        width: 100%;
        max-width: 768px;
        /*height: 566px;*/
        margin: 0 auto;
    }

    .box_36 {
        /*
        width: 100%;
        height: 328px;
        border: 1px solid #979797;
        background:
                linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%)
                no-repeat center/cover;
        position: relative;
        transition: 0.3s ease;

        overflow: hidden;
        */
        width: 100%;
        height: 165px; /* 默认高度 */
        position: relative;
        display: flex;
        justify-content: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

    }

    .box_36 .box36_content {
        /*
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background:
                linear-gradient(90deg, #f3f3f3 25%, #e0e0e0 50%, #f3f3f3 75%),
                no-repeat center/cover;
        transition: transform 0.3s ease; /* 缩放过渡 */
        width: 100%;
        height: 165px; /* 默认高度 */
        position: relative;
        display: flex;
        justify-content: center;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    /* 悬停时仅缩放内容层 */
    .box_36:hover .box36_content {
        transform: scale(1.2);
    }


    /* 错误状态 */
    .box_36.error {
        /* background: #f8f9fa url('~@/assets/error-image.png') no-repeat center/30%;*/
    }

    .box_37 {
        background-color: rgba(249, 249, 251, 1);
        width: 100%;
        max-width: 769px;
        height: 238px;
        transition: background-color 0.3s ease;
    }
    .box_37:hover {
        background-color: rgba(255, 255, 255, 1) !important; /* 悬停时强制覆盖背景色 */
    }
    .group_36:hover {
        background-color: rgba(255, 255, 255, 1) !important; /* 悬停时强制覆盖背景色 */
    }

    /* 新闻标题 hover 效果 */
    .text_77:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }

    /* "查看更多" 链接 hover 效果 */
    .text-group_28:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }
    .text_82:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }
    .text-group_33:hover {
        color: #008683 !important;
        transition: color 0.3s ease;
    }

    .text_76 {
        width: 94px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 156, 134, 1);
        font-size: 16px;
        letter-spacing: 0.007703703828155994px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 22px;
        margin: 25px 0 0 21px;
    }

    .text_77 {
        width: 100%;
        max-width: 422px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 22px;
        letter-spacing: 0.010592592880129814px;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin: 6px 0 0 21px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .text_78 {
        width: 90%;
        max-width: 729px;
        height: 44px;
        overflow-wrap: break-word;
        color: #666666;
        font-size: 16px;
        letter-spacing: 0.007703703828155994px;
        text-align: left;
        line-height: 22px;
        margin: 8px 0 0 21px;
        cursor: pointer;
    }
    /* 添加CSS样式 */
    .clamp-2 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 限制两行 */
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.4; /* 根据实际字体大小调整 */
        max-height: 3em; /* 行高*行数 */
    }

    /* 可选：处理块级元素影响行高计算 */
    .clamp-2 >>> * {
        display: inline !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .image-text_270 {
        width: 70px;
        height: 20px;
        margin: 21px 0 0 24px;
    }

    .text-group_28 {
        cursor: pointer;
        width: 57px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        letter-spacing: 0.006740740966051817px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .thumbnail_1 {
        width: 7px;
        height: 12px;
        margin-top: 4px;
    }

    .box_38 {
        background-color: rgba(39, 161, 144, 1);
        width: 769px;
        height: 4px;
        margin-top: 58px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .news-list .group_185 {
        width: 100% !important;
        max-width: 768px; /* 与主新闻区块严格一致 */
        margin: 0 auto;
        padding: 0; /* 清除可能影响宽度的内边距 */
    }
    .group_185 {

        width: 100% !important;
        max-width: 768px;
        margin: 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .group_36 {
        background-color: rgba(249, 249, 251, 1);
        width: 100%;
        box-sizing: border-box;
    }


    .text-group_369 {
        width: calc(100% - 48px);
        height: 59px;
        margin: 30px 0 0 24px;

        margin-left: 0 !important;
        padding: 0 24px;
    }

    .text_81 {
        width: 94px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 156, 134, 1);
        font-size: 16px;
        letter-spacing: 0.007703703828155994px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 22px;
    }

    .text_82 {
        cursor: pointer;
        height: 26px;

        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.008666666224598885px;
        text-align: left;
        white-space: nowrap;
        line-height: 26px;
        margin-top: 11px;

        overflow: hidden;
        text-overflow: ellipsis;

        overflow-wrap: normal;

        width: calc(100% - 24px) !important;
        max-width: 650px;

    }



    .box_40 {
        background-color: rgba(232, 232, 232, 1);
        height: 1px;
        width: calc(100% - 48px) !important;
        margin: 30px 24px 0 !important;
    }

    .group_40 {
        width: 100%;
        height: 82px;
        background: url(../../../assets/index/chpc_index_news_bc.png) 100% no-repeat;
        background-size: 100% 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .image-text_271 {
        cursor: pointer;
        width: 86px;
        height: 26px;
        margin: 28px auto 0 auto;
        width: fit-content;
    }

    .text-group_33 {
        width: 73px;
        height: 26px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.008666666224598885px;

        text-align: left;
        white-space: nowrap;
        line-height: 26px;
    }

    .thumbnail_2 {
        width: 7px;
        height: 12px;
        margin-top: 7px;
    }


    /* 响应式调整 */
    @media (max-width: 600px) {
        .box_36,
        .box_37,
        .group_36 {
            width: 100% !important;
            max-width: 100%;
        }
        .text_74 {
            font-size: 25px;
        }

        .text_75 {
            font-size: 14px;
            margin-top: -10px;
        }

        .text_77,
        .text_78 {
            width: 95% !important;
        }
        .text_77, .text_82{
            font-size: 16px;
        }
        .text_78{
            font-size: 13px;
        }
        .block_96,box_36 {
            width: 400px;
        }
        .block_95 {
            margin: 5px auto 0;
        }

        .text-group_369 {
            width: calc(100% - 20px);
            margin: 30px 0 0 10px;
            padding: 0 10px;
        }
        .box_40 {
            background-color: rgba(232, 232, 232, 1);
            height: 1px;
            width: calc(100% - 20px) !important;
        }
    }
    @media (min-width: 601px) and (max-width: 700px){
        .block_96,box_36 {
            width: 600px;
        }
    }

</style>
